import React from 'react';
function ButtonComment(props: any) { 

    const {onClick} = props; 

    return (
        <button
        onClick={onClick}
        className="btn btn-comment-submit"
        id="btn-open-modal-comment"
        >
            <span className="btn-text">Comentar</span>
        </button>
    );
}

export default ButtonComment;